<template>
  <div>
    <Navigation />
    <v-container>
      <v-card>
        <v-card-title>
          Users
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
        </v-card-title>
        <v-data-table item-key="id" :headers="headers" :items="user_list" :search="search" :items-per-page="25"
          loading="isFetchingData"></v-data-table>
      </v-card>
    </v-container>

  </div>
</template>

<script>
import { get_secretary_users } from '../api'
import Navigation from '../components/Navigation'
import store from '../store'

export default {
  components: {
    Navigation
  },
  data() {
    return {
      isFetchingData: true,
      search: '',
      headers: [
        {
          text: 'First Name',
          align: 'start',
          value: 'first_name'
        },
        {
          text: 'Last Name',
          value: 'last_name',
        },
        {
          text: 'Middle Name',
          value: 'middle_name',
        },
        {
          text: 'Email',
          value: 'email',
        },
        {
          text: 'Mobile',
          value: 'mobile',
        },
        {
          text: 'Role',
          value: 'role',
        },
      ],
      user_list: []
    }
  },
  mounted() {
    const jwt = store.getters.getJwt
    get_secretary_users(jwt).then(response => {
      this.user_list = response.data.users
      this.isFetchingData = false
    })

  }

}
</script>

<style></style>